/**
 * @classdesc Load Vimeo script to be able to generate videos
 *
 * @class YoutubeApiLoader
 * @version 1.0.0
 * @path
 * @see {@link YoutubeVideoPlayerDriver}
 */
class YoutubeApiLoader {
	static apiUrl = 'https://www.youtube.com/iframe_api';
	static apiCallbackName = 'onYouTubeIframeAPIReady';

	promise = null;

	/**
	 * Embeds the script and when it is loaded it resolve with the object that implements the
	 * Youtube API
	 *
	 * @returns {Promise<object>} Contains the Player object that implements the Youtube API
	 */
	load() {
		if (this.promise === null) {
			this.promise = new Promise((resolve) => {
				/* eslint-disable-next-line piggyback/no-restricted-global-extend */
				window[this.constructor.apiCallbackName] = () => {
					console.log('youtube api ready');
					/* eslint-disable-next-line piggyback/no-restricted-global-extend */
					resolve(window.YT);
				};
				const script = document.createElement('script');
				script.async = true;
				script.defer = true;
				script.setAttribute('src', this.constructor.apiUrl);
				document.body.appendChild(script);
			});
		}
		return this.promise;
	}
}

/**
 * the shared instance of the loader among all the Youtube Drivers in the page
 *
 * @type {YoutubeApiLoader}
 */
const youtubeApiLoader = new YoutubeApiLoader();

export {youtubeApiLoader, YoutubeApiLoader};
